import { Injectable } from '@angular/core';
import { AsyncSubject, Observable, distinctUntilChanged, map, noop } from 'rxjs';

import { EvaluationTemplate } from '../models/evaluation.model';
import { DistinctSubject, recursiveQuery } from '../models/utility.model';
import { AuthUsecase } from '../usecases/auth.usecase';
import { EvaluationGateway } from '../usecases/evaluation.gateway';
import { EvaluationUsecase } from '../usecases/evaluation.usecase';

@Injectable()
export class EvaluationInteractor extends EvaluationUsecase {
  get evaluationTemplates$(): Observable<EvaluationTemplate[]> {
    return this._evaluationTemplates;
  }

  private readonly _evaluationTemplates = new DistinctSubject<EvaluationTemplate[]>([]);

  constructor(
    private _authUsecase: AuthUsecase,
    private _evaluationGateway: EvaluationGateway,
  ) {
    super();

    this._authUsecase.authState$
      .pipe(
        map(({ status }) => status === 'signedIn'),
        distinctUntilChanged(),
      )
      .subscribe(signedIn => (signedIn ? noop : this.onSignOut()));
  }

  listEvaluationTemplates(): Observable<never> {
    const result = new AsyncSubject<never>();
    recursiveQuery(params => this._evaluationGateway.listEvaluationTemplates(params), {}, true).subscribe({
      next: evaluations => this._evaluationTemplates.next(evaluations),
      error: result.error.bind(result),
      complete: result.complete.bind(result),
    });
    return result.asObservable();
  }

  clearEvaluations(): void {
    this._evaluationTemplates.next([]);
  }

  private onSignOut(): void {
    this._evaluationTemplates.next([]);
  }
}
